import { FC, useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { withPreloader } from 'shared/ui/spinner';
import { Panel } from 'shared/ui/panel';
import {
  getOrderInfo,
	OrderInfoShort,
	selectOrderLoader,
	selectOrdersError,
	useOrderInfo,
} from 'entities/orders';
import { OrderDetailButtons } from '../buttons/orderDetailButtons';
import { OrderDetailProps } from '../types';
import { PersonModalCard } from 'widgets/personModalCard';
import { ModalProvider } from 'shared/ui/modal';
import { OrderDetailHeader } from './orderDetailHeader';
import { MAIN_BG_COLOR } from 'shared/consts';
import { selectOrderInfoForBooking } from 'entities/orders/model/selectors';

export const OrderDetailInfo: FC<OrderDetailProps> = ({
	goToBookingBtn = false,
	fetchData,
	includeButtons = true,
	maxHeightPanel = '',
  heightPanel = '',
	includePenButton = true,
	includeContactInfo = true,
	includeCloseButton = true,
	infoTitle = 'Бронирование',
	softDesign = false,
	includePenButtonInPerson = true,
	updateOrderInPersonModal,
  minusHeight,
  hideRestore = false,
  closeWhenNotOrder = true,
}) => {
	const OrderInfoWithLoader = useMemo(() => {
    return withPreloader(OrderInfoShort)
  }, []);

	const { isOpen, selectedInfoId, close } = useOrderInfo();

	const order = useAppSelector(selectOrderInfoForBooking);

	const isLoading = useAppSelector(selectOrderLoader);
	const error = useAppSelector(selectOrdersError);

	const dispatch = useAppDispatch();

	useEffect(() => {
		if (isOpen && selectedInfoId) {
			dispatch(getOrderInfo({ id: selectedInfoId }));
		}
	}, [isOpen, selectedInfoId, dispatch]);

	useEffect(() => {
		if (!order&&closeWhenNotOrder) {
			close?.();
		}
	}, [order, close, closeWhenNotOrder]);

	return (
		<Panel
			isOpen={isOpen}
			mediaHeight={true}
			maxHeight={maxHeightPanel}
			height={heightPanel}
			includePadding={false}
			background={softDesign ? MAIN_BG_COLOR : undefined}
			roundedBorders={softDesign}
      minusHeight={minusHeight}
		>
			{!isLoading && order && (
				<OrderDetailHeader
					includeCloseButton={includeCloseButton}
					includePenButton={includePenButton}
					open={() => null}
					close={() => null}
					order={order}
					roundedBorders={softDesign}
				/>
			)}

			<ModalProvider>
				<PersonModalCard
					showOrderEdit={includePenButtonInPerson}
					updateOrder={updateOrderInPersonModal}
				/>
				<OrderInfoWithLoader
					order={order}
					includeContactInfo={includeContactInfo}
					title={infoTitle}
					isLoading={false}
					error={error}
          isModal={true}
				/>
			</ModalProvider>

			{!isLoading && order && includeButtons && (
				<OrderDetailButtons
					order={order}
					goToBookingBtn={goToBookingBtn}
					fetchData={fetchData}
          hideRestore={hideRestore}
				/>
			)}
		</Panel>
	);
};
